import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffVacationBalanceResponse,
  StaffVacationCancellationResponse,
  StaffVacationCreateRequest,
  StaffVacationDecisionRequest,
  StaffVacationDecisionResponse,
  StaffVacationEntitlementRequest,
  StaffVacationMovementResponse,
  StaffVacationRequestDetailResponse,
  StaffVacationRequestResponse,
  StaffVacationRequestStatus,
  StaffVacationTypeResponse,
} from "../model/vacation.model";

@Injectable({ providedIn: "root" })
export class StaffVacationsService {
  private readonly apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.apiUrl = `${basePath.replace(/\/$/, "")}/api/v1`;
  }

  listTypes(): Observable<StaffVacationTypeResponse[]> {
    return this.http.get<StaffVacationTypeResponse[]>(
      `${this.apiUrl}/vacation-types`,
    );
  }

  getBalance(employeeId: number): Observable<StaffVacationBalanceResponse> {
    return this.http.get<StaffVacationBalanceResponse>(
      `${this.apiUrl}/vacation-balances/${employeeId}`,
    );
  }

  setEntitlement(
    employeeId: number,
    request: StaffVacationEntitlementRequest,
  ): Observable<StaffVacationBalanceResponse> {
    return this.http.put<StaffVacationBalanceResponse>(
      `${this.apiUrl}/vacation-balances/${employeeId}`,
      request,
    );
  }

  listMovements(employeeId: number): Observable<StaffVacationMovementResponse[]> {
    return this.http.get<StaffVacationMovementResponse[]>(
      `${this.apiUrl}/vacation-balances/${employeeId}/movements`,
    );
  }

  listRequests(filters?: {
    employeeId?: number;
    status?: StaffVacationRequestStatus;
  }): Observable<StaffVacationRequestResponse[]> {
    let params = new HttpParams();
    if (filters?.employeeId != null) {
      params = params.set("employeeId", filters.employeeId);
    }
    if (filters?.status) {
      params = params.set("status", filters.status);
    }
    return this.http.get<StaffVacationRequestResponse[]>(
      `${this.apiUrl}/vacation-requests`,
      { params },
    );
  }

  getRequest(requestId: number): Observable<StaffVacationRequestDetailResponse> {
    return this.http.get<StaffVacationRequestDetailResponse>(
      `${this.apiUrl}/vacation-requests/${requestId}`,
    );
  }

  createRequest(
    request: StaffVacationCreateRequest,
  ): Observable<StaffVacationRequestResponse> {
    return this.http.post<StaffVacationRequestResponse>(
      `${this.apiUrl}/vacation-requests`,
      request,
    );
  }

  decideRequest(
    requestId: number,
    request: StaffVacationDecisionRequest,
  ): Observable<StaffVacationDecisionResponse> {
    return this.http.post<StaffVacationDecisionResponse>(
      `${this.apiUrl}/vacation-requests/${requestId}/decision`,
      request,
    );
  }

  cancelRequest(requestId: number): Observable<StaffVacationCancellationResponse> {
    return this.http.post<StaffVacationCancellationResponse>(
      `${this.apiUrl}/vacation-requests/${requestId}/cancel`,
      null,
    );
  }
}
